import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from "@mui/material";
import { Icons } from "../../../config/MuiIcons.config";
import AppButton from "../../../components/CommonReusableComponent/AppButton/AppButton";
import { useSnackbar } from "../../../contexts/Snackbar.context";
import { ERROR_MESSAGE, SNACKBAR_VARIANT } from "../../../config/Messages.config";
import WarningImage from "../../../assets/images/Warning.svg"

const DeleteBranchConfirmationModal = ({
  ModalState,
  SetModalState,
  ToggleFunction,
  OnSubmit,
  LoaderState,
}) => {
  const { showSnackbar } = useSnackbar()
  return (
    <Dialog
      open={ModalState}
      aria-labelledby="form-dialog-title"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle style={{ textAlign: "center" }}>
        <IconButton
          aria-label="close"
          onClick={() => {
            ToggleFunction("Delete Plant")
            SetModalState(null)
          }}
          style={{ position: "absolute", right: 8, top: 8 }}
        >
          <Icons.Close />
        </IconButton>
        <img src={WarningImage} alt="warning-img" style={{width: '45px', height: '45px'}}/>
      </DialogTitle>
      <DialogContent style={{ textAlign: "center" }}>
        <Typography style={{ fontSize: "24px" }} className="inter-regular-400">
          Are you sure
        </Typography>
        <Typography style={{ fontSize: "16px" }} className="inter-regular-400">
          Do you want to delete this Branch?
        </Typography>
      </DialogContent>
      <DialogActions className="justify-content-center mb-3 mx-5">
        <AppButton
          OnPress={() => {
            ToggleFunction("Delete Branch")
            SetModalState(null)
          }}
        >
          Cancel
        </AppButton>
        <AppButton
          Color={"error"}
          OnPress={() => {
            if (navigator.onLine) {
              OnSubmit();
            } else {
              showSnackbar(ERROR_MESSAGE.INTERNET_ERROR, SNACKBAR_VARIANT.ERROR)
            }
          }}
          LoadingState={LoaderState}
          IsDisabled={LoaderState}
        >
          Delete
        </AppButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteBranchConfirmationModal;
